import { buildApiTypes } from '@/modules/Vuex';

export const { actionTypes: API_ACCOUNT_UPDATE } = buildApiTypes('preferences/API_ACCOUNT_UPDATE');
export const { actionTypes: API_GET_ACCOUNT } = buildApiTypes('preferences/API_GET_ACCOUNT');
